import React from "react";
import { translations } from "../../base.js";

const Footer = () => {
    return (
        <div className="footer">
            {translations.SiteTitle} &copy; {new Date().getFullYear()}
        </div>
    );
};

export default Footer;
